import { EventNominee } from "../../types";
import { formatNominee } from "./utils";

interface WinnerCellProps {
  winners: EventNominee[];
  displayMode: "movie_first" | "person_first";
}

const WinnerCell = ({ winners, displayMode }: WinnerCellProps) => (
  <div
    role="cell"
    className="flex items-center justify-center text-center px-2 py-2 md:px-3 min-h-[56px]"
  >
    {winners.length > 0 ? (
      <div className="flex flex-col gap-2">
        {winners.map((winner) => {
          const { primary, secondary } = formatNominee(winner, displayMode);

          return (
            <div key={winner.id} className="inline-block px-2 py-1">
              <p
                className="text-base md:text-lg font-semibold text-letterboxd-text-primary leading-snug mb-0 font-letterboxdBody"
              >
                {primary}
              </p>
              {secondary && (
                <p className="text-[10px] md:text-xs text-letterboxd-text-muted">
                  {secondary}
                </p>
              )}
            </div>
          );
        })}
      </div>
    ) : (
      <>
        <span aria-hidden="true" className="text-letterboxd-text-muted text-xs">
          &mdash;
        </span>
        <span className="sr-only">Not announced</span>
      </>
    )}
  </div>
);

export default WinnerCell;
